<p-dialog
  header="Associação de EPI"
  [(visible)]="visible"
  [style]="{
    width: '50rem',
  }"
  [draggable]="false"
  (onHide)="onHide()"
>
  <div class="header">
    <app-titulo text="Termos de Aceite"></app-titulo>
  </div>
  <div class="body" #dialogBody>
    <div class="pdf">
      <pdf-viewer
        [src]="pdfSrc"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="false"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
      ></pdf-viewer>
    </div>
    <div class="terms-acceptance">
      <input type="checkbox" id="checkTermos" [(ngModel)]="checkTermos" />
      <label for="checkTermos">Estou ciente e aceito os termos</label>
    </div>
    <app-botao
      width="100%"
      text="Concluir associação"
      [disabled]="!checkTermos"
      (click)="aceitarTermos()"
    ></app-botao>
  </div>
</p-dialog>

<div *ngIf="visible" class="blur-overlay"></div>
